import { Box } from "@material-ui/core";
import { FunctionComponent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CTAButton } from "..";
import { toggleRequestCallbackModal } from "../../Redux/Actions";
import { RootState } from "../../Redux/Reducers";
import GreenTick from "@/Assets/images/check-sucess.gif";
import { CustomDialog, CustomDialogContent, useStyles } from "./style";

interface RequestCallbackSuccessPopupProps {
  show?: boolean;
  onClose?: () => void;
  heading?: string | undefined;
  description?: string | undefined;
  ctaText?: string | undefined;
  inRootTree?: boolean;
}

const RequestCallbackSuccessModal: FunctionComponent<RequestCallbackSuccessPopupProps> = ({
  inRootTree,
  ...props
}: RequestCallbackSuccessPopupProps): JSX.Element => {
  const classes: any = useStyles();
  const dispatch = useDispatch();
  const { showRequestCallbackModal, disableRequestCallbackModalInRoot } = useSelector((state: RootState) => ({
    showRequestCallbackModal: state.subscriptionReducer.showRequestCallbackModal,
    disableRequestCallbackModalInRoot: state.subscriptionReducer.disableRequestCallbackModalInRoot,
  }));

  if (inRootTree && disableRequestCallbackModalInRoot) {
    return null;
  }
  const onClose = () => dispatch(toggleRequestCallbackModal(false));

  return (
    <CustomDialog open={showRequestCallbackModal} fullWidth onClose={onClose}>
      <CustomDialogContent className="relative tw-ph-[16px] flex justify-center items-center !tw-pb-[24px] sm:!tw-px-[40px] sm:!tw-py-[40px]">
        <Box className={classes.contentWrap}>
          <Box className="flex flex-column justify-between items-center tw-mt-[32px]">
            <img src={GreenTick} className="" height={70} width={70}></img>
          </Box>
          <Box className="f5 tc">
            <p className="tw-m-0 tw-mb-[8px] tw-mt-[24px] tw-text-[22px] tw-font-medium">
              {props.heading ?? "You have taken a step towards growing your business online!"}
            </p>
            <p className="tw-m-0 tw-text-[16px] tw-font-normal tw-text-[#6B6B6B]">
              {props.description ?? "We will call you back within 1 business day."}
            </p>
          </Box>
          <Box className="tc">
            <CTAButton
              text={props.ctaText ?? "Okay"}
              customClasses="!tw-h-[50px] !tw-bg-[#2B74D8] !tw-mt-[32px] !tw-rounded-[8px] !tw-border-none !tw-text-[16px] !tw-w-[100%] sm:!tw-w-[152px]"
              onClick={onClose}
            />
          </Box>
        </Box>
      </CustomDialogContent>
    </CustomDialog>
  );
};

export default RequestCallbackSuccessModal;
